import PropTypes from 'prop-types'
import {Flex} from '@chakra-ui/react'

const InputFlexWrap = ({children}) => (
  <Flex
    align="left"
    justifyContent="start"
    py="sm"
    flexDirection={{base: 'column', sm: 'row'}}
    gap="xs"
    alignItems={{base: 'flex-start', sm: 'center'}}
  >
    {children}
  </Flex>
)

InputFlexWrap.propTypes = {
  children: PropTypes.node.isRequired,
}

export default InputFlexWrap
